import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api';
import { setStore, removeStore, store } from '../../../app/store';
import Header from '../../Universal/Header';
import Swal from 'sweetalert2';
import Footer from '../../Universal/Footer';
import fbIcon from '../../../assets/img/fb-icon.png';
import youtubeIcon from '../../../assets/img/youtube-icon.png';

const { REACT_APP_BRANDURL } = process.env;

// Add CSS for skeleton loader animation
const skeletonStyles = `
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`;

if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = skeletonStyles;
  document.head.appendChild(style);
}

export default function Contact() {
  const [FormData, setFormData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    email_id: '',
    mobile_number: '',
    message: ''
  });
  const store_data = JSON.parse(store());
  const [Loading, setLoading] = useState(false);
  const [ContactStatus, setContactStatus] = useState(null);
  const [HeroData, setHeroData] = useState(null);
  const [HeroLoading, setHeroLoading] = useState(true);

  // Fallback hero data for 'contact' route
  const fallbackHeroData = {
    title: 'Contact Us',
    description: 'From a small group of ex-students meeting in Salt Lake in 1986 to a thriving alumni community today, the BE College Ex-Students\' Club has grown on the values of camaraderie, respect, and shared pride in our alma mater.',
    image: `${REACT_APP_BRANDURL}theme/assets/images/contact-banner.jpg`,
    route: 'contact'
  };

  useEffect(() => {
    if (store_data?.email_id) {
      setFormData(prev => ({
        ...prev,
        email_id: store_data.email_id || '',
        mobile_number: store_data.mobile_number || ''
      }));
    }
  }, [store_data?.is_login]);

  // Fetch hero data for 'contact' route
  useEffect(() => {
    fetchHeroData();
  }, []);

  const fetchHeroData = async () => {
    try {
      setHeroLoading(true);
      const response = await postAPI('hero-data/fetchData/contact', {});

      console.log('API Response:', response);

      if (response?.status === 1 && response?.data) {
        console.log('Hero data fetched:', response.data);
        setHeroData(response.data);
      } else {
        console.warn('Failed to fetch hero data, using fallback');
        setHeroData(fallbackHeroData);
      }
    } catch (error) {
      console.error('Error fetching hero data:', error);
      setHeroData(fallbackHeroData);
    } finally {
      setHeroLoading(false);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...FormData,
      [name]: value
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Validate form
      if (!FormData.first_name || !FormData.last_name || !FormData.email_id || !FormData.message) {
        setContactStatus({ status: 0, msg: "Please fill in all required fields" });
        return;
      }

      setLoading(true);
      const response = await postAPI(`contact/create`, FormData);

      if (response?.status === 1) {
        Swal.fire({
          title: "Good job!",
          text: response?.msg || "Message sent successfully!",
          icon: "success"
        });
        setContactStatus({ status: 1, msg: response?.msg || "Message sent successfully!" });
        // Reset form
        setFormData({
          first_name: '',
          middle_name: '',
          last_name: '',
          email_id: store_data?.email_id || '',
          mobile_number: store_data?.mobile_number || '',
          message: ''
        });
      } else {
        setContactStatus({ status: 0, msg: response?.msg || "Failed to send message" });
      }
    } catch (e) {
      console.error('Contact error:', e);
      setContactStatus({ status: 0, msg: e.message || "An error occurred" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Header />
      <section className="hero-section">
        <div className="banner-image">
          {HeroLoading ? (
            <div style={{
              height: '500px',
              backgroundColor: '#e0e0e0',
              animation: 'pulse 1.5s infinite',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{ color: '#999' }}>Loading...</span>
            </div>
          ) : (
            <img
              src={HeroData?.backgroundImage ? (HeroData.backgroundImage.startsWith('http') ? HeroData.backgroundImage : `${process.env.REACT_APP_APIURL || 'https://beapi.shikshaprime.com/'}${HeroData.backgroundImage.startsWith('/') ? HeroData.backgroundImage.slice(1) : HeroData.backgroundImage}`) : fallbackHeroData.image}
              className="img-fluid"
              alt="banner"
              onError={(e) => { e.target.src = fallbackHeroData.image; }}
            />
          )}
        </div>
        <div className="hero-content">
          {HeroLoading ? (
            <>
              <div className="skeleton-loader" style={{ height: '60px', backgroundColor: '#e0e0e0', marginBottom: '20px', animation: 'pulse 1.5s infinite', borderRadius: '4px' }} />
              <div className="skeleton-loader" style={{ height: '80px', backgroundColor: '#e0e0e0', animation: 'pulse 1.5s infinite', borderRadius: '4px' }} />
            </>
          ) : (
            <>
              <h1
                className="fw-bold display-5"
              >
                {HeroData?.title || fallbackHeroData.title}
              </h1>
              <p
                className="mt-lg-3 mt-1 mb-0"
                style={{
                  color: HeroData?.descriptionColor || '#ffffff',
                  fontFamily: HeroData?.descriptionFont || 'Arial'
                }}
              >
                {HeroData?.description || fallbackHeroData.description}
              </p>
            </>
          )}
        </div>
      </section>
      <section className="inner-contact-info">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="item">
                <h3>Email</h3>
                <hr className="my-3" />
                <a href="mailto:becollegeexstudent@gmail.com">becollegeexstudent@gmail.com</a>
                {/* <a href="#map" className="map-link"><img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/address-icon.svg`} alt="address" />View on google map</a> */}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="item">
                <h3>Phone</h3>
                <hr className="my-3" />
                <a href="tel:+03340016318">+033 4001 6318</a>
                {/* <a href="#map" className="map-link"><img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/address-icon.svg`} alt="address" />View on google map</a> */}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="item">
                <h3>Address</h3>
                <hr className="my-3" />
                <p>C-K-14, 2nd Avenue, CK Block, Sector II, Bidhannagar, Kolkata, West Bengal 700091</p>
                <a href="#map" className="map-link"><img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/address-icon.svg`} alt="address" />View on Google Map</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="inner-contact">
        <div className="container-fluid container-xxl container-xxl">
          <div className="row align-items-center justify-content-xl-between justify-content-center">
            <div className="col-xl-5 col-lg-5 col-md-5 text-center text-lg-start text-md-start mb-lg-0 mb-md-0 mb-3">
              <h2>Get in Touch</h2>
              <p>We'd love to hear from you! Reach out to us for information on membership, events, or collaborations. The BE College Ex-Students' Club values every connection — because together, we keep the spirit of our alma mater alive.</p>
              <p><strong>Feel free to get in touch with us via social media</strong></p>
              <div className="d-flex align-items-center justify-content-lg-start justify-content-md-start justify-content-center social-media">
                <a href="https://www.facebook.com/BECollegeExstudentsClub/" target="_blank" rel="noopener noreferrer" className="me-3">
                  <img src={fbIcon} alt="facebook" />
                </a>
                <a href="https://www.youtube.com/@b.e.collegeex-studentsclub9837" target="_blank" rel="noopener noreferrer">
                  <img src={youtubeIcon} alt="youtube" />
                </a>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6 col-md-7">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label>First name: <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter first name *"
                        name="first_name"
                        value={FormData.first_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label>Last name: <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter last name *"
                        name="last_name"
                        value={FormData.last_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="form-group">
                  <label>Middle name (optional):</label>
                  <input 
                    type="text" 
                    placeholder="Enter middle name" 
                    name="middle_name"
                    value={FormData.middle_name}
                    onChange={handleChange}
                  />
                </div> */}
                <div className="form-group">
                  <label>Enter email: <span className="text-danger">*</span></label>
                  <input
                    type="email"
                    placeholder="Enter email *"
                    name="email_id"
                    value={FormData.email_id}
                    onChange={handleChange}
                    required
                  />
                </div>
                {/* <div className="form-group">
                  <label>Mobile number (optional):</label>
                  <input 
                    type="tel" 
                    placeholder="Enter mobile number" 
                    name="mobile_number"
                    value={FormData.mobile_number}
                    onChange={handleChange}
                  />
                </div> */}
                <div className="form-group">
                  <label>Enter message: <span className="text-danger">*</span></label>
                  <textarea
                    placeholder="Your message"
                    name="message"
                    value={FormData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                {/* {ContactStatus && (
                  <div className={`alert alert-${ContactStatus.status === 1 ? 'success' : 'danger'} mt-3`}>
                    {ContactStatus.msg}
                  </div>
                )} */}
                <div className="cus-btn">
                  <button type="submit" className="btn-cus" disabled={Loading}>
                    {Loading ? 'Sending...' : 'Contact us'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <section className="map" id="map">
        <div className="container-fluid container-xxl container-lg">
          <div className="row">
            <div className="col-lg-12">
              <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3683.841235042205!2d88.42380057507808!3d22.585040579482904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sC-K-14%2C%202nd%20Avenue%2C%20CK%20Block%2C%20Sector%20II%2C%20Bidhannagar%2C%20Kolkata%2C%20West%20Bengal%20700091!5e0!3m2!1sen!2sin!4v1767015017054!5m2!1sen!2sin" width="100%" height="450" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
